// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__JM6jt","emoji":"style_emoji___mXqE","description":"style_description__JVftu","input":"style_input__UcnXg"};